// darkTheme.js
import appTheme from "../theme";
import { alpha } from "@mui/material/styles";
import { common } from "@mui/material/colors";

const neutral = {
  50: "#F8F9FA",
  100: "#F3F4F6",
  200: "#E6F0F9",
  300: "#D2D6DB",
  400: "#9DA4AE",
  500: "#5e6c84",
  600: "#6C737F",
  700: "#4D5761",
  800: "#2F3746",
  900: "#111927",  
};

const colorPalette = {
  primary: {
    light: "#42a5f5",
    main: "#1976d2",
    dark: "#1565c0",
    contrastText: "#fff",
  },
  secondary: {
    main: "#FF5733",
    // light: will be calculated from palette.primary.main,
    // dark: will be calculated from palette.primary.main,
    // contrastText: will be calculated to contrast with palette.primary.main
  },
  neutral,
  background: {
    default: common.white,
    paper: common.white,
  },
  text: {
    primary: neutral[900],
    secondary: neutral[500],
    disabled: alpha(neutral[900], 0.38),
  },
  action: {
    active: neutral[500],
    disabled: alpha(neutral[900], 0.38),
    disabledBackground: alpha(neutral[900], 0.12),
    focus: alpha(neutral[900], 0.16),
    hover: alpha(neutral[900], 0.04),
    selected: alpha(neutral[900], 0.12),
  },
  success: {
    main: "#4caf50",
    light: "#2e7d32",
    dark: "#1b5e20",
  },
  error: {
    main: "#ef5350",
    light: "#d32f2f",
    dark: "#c62828",
  },
  warning: {
    main: "#ff9800",
    light: "#ed6c02",
    dark: "#e65100",
  },
};

var theme = appTheme(
  colorPalette.primary.main,
  colorPalette.primary.contrastText,
  colorPalette
);

const darkTheme = {
  ...theme,
  palette: {
    mode: "dark",
    ...colorPalette,
  },
};

export default darkTheme;
